import { ROUTES } from './routes';
import { HydratedRouteInterface, RouteInterface } from '../types/routes';
import { CompanyTrackerRoute } from '../routes/company-tracker';
import { PortfolioTrackerEntryRoute } from '../apps/portfolio-tracker/routes/PortfolioTrackerEntryRoute';
import { AssuranceRoute } from '../apps/assurance/routes/AssuranceRoute';
import { MaterialityTrackerRoute } from '../apps/materiality-tracker/routes/MaterialityTrackerRoute';
import { StatsRoute } from '../routes/stats';
import { WaitingComponent } from '../utils/component';
import { WorldTrackerRoute } from '../routes/world-tracker/WorldTrackerRoute';
import { ThemeShowcaseRoute } from '../routes/theme-showcase';

const ROUTE_APP_ENTRY: { [K in keyof typeof ROUTES]: HydratedRouteInterface['component'] } = {
  COMPANY_TRACKER: CompanyTrackerRoute,
  PORTFOLIO_TRACKER: PortfolioTrackerEntryRoute,
  ASSURANCE: AssuranceRoute,
  STATS: StatsRoute,
  MATERIALITY_TRACKER: MaterialityTrackerRoute,
  WORLD_TRACKER: WaitingComponent(WorldTrackerRoute),
  THEME_SHOWCASE: ThemeShowcaseRoute,
} as const;

export const getHydratedAppEntryRoute = (route: RouteInterface, componentKey: keyof typeof ROUTES): HydratedRouteInterface => {
  return {
    ...route,
    component: ROUTE_APP_ENTRY[componentKey],
  };
};
